import { useLocalStorage } from '../hooks/useLocalStorage';

const fetchLink = 'https://offers-tiger-trade.affise.com/postback';

export const useAffise = () => {
  const { get } = useLocalStorage();
  let price;
  // TODO refactoring
  const prices = [
    { priceUsd: '49', priceRub: '2900' },
    { priceUsd: '124', priceRub: '6900' },
    { priceUsd: '399', priceRub: '21900' },
    { priceUsd: '1500', priceRub: '99900' },
    { priceUsd: '15', priceRub: '1000' },
  ];

  function sendAffiseEvent(goal?: string, label?: string) {
    const clickId = get('clickId');
    if (clickId) {
      const purchaseSum = get('purchaseSum');
      const paramClickId = `clickid=${clickId}`;
      const paramGoal = goal ? `&goal=${goal}` : '';
      const paramLabel = label ? `&sub1=${label}` : '';

      const currentPrice = prices.find((f) => {
        return purchaseSum === +f.priceUsd || purchaseSum === +f.priceRub;
      });
      price = currentPrice?.priceUsd;

      const paramSum = price && goal === 'Purchase' ? `&sum=${price}` : '';
      const params = paramClickId + paramGoal + paramLabel + paramSum;

      return fetch(`${fetchLink}?${params}&f5809319e09257fc55771a3d6c404edb=1`);
    }
    return null;
  }
  return { sendAffiseEvent };
};
